/**
 * 用户确认弹框组件
 */
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import './index.less'

export function Popup(props: {
  /** 标题 */
  title: string
  /** 指定className */
  class?: string
  /** 确认事件 */
  onConfirm: Function
  /** 取消事件 */
  onCancel: Function
}) {
  const [animate, setAnimate] = useState('')
  let timer:any = null

  const cancel = () => {
    setAnimate("animate-none")
    timer = setTimeout(()=>{
        props.onCancel()
    },300)
  }

  const confirm = () => {
    setAnimate("animate-none")
    timer = setTimeout(()=>{
        props.onConfirm()
    },300)
  }

  useEffect(() => {
    setAnimate('animate-block')
    return ()=>{timer && clearTimeout(timer)}
  }, [])

  return ReactDOM.createPortal(
    <>
      <div className={`popup default-popup ${animate}`}>
        <div className="content-body">
          <div className={props.class ?? ''}>{props.title}</div>
        </div>
        <footer>
          <a
            href="#"
            className="default-popup-cancel popup-button"
            onClick={(e) => {
              e.preventDefault();
              cancel()
            }}
          >
            取消
          </a>
          <a
            href="#"
            className="default-popup-ok button"
            onClick={(e) => {
              e.preventDefault();
              confirm()
            }}
          >
            确认
          </a>
        </footer>
      </div>
      <div className="pop-mask"></div>
    </>,
    document.body
  )
}
